if(window.location.href.includes('/cart')){
  setTimeout(()=>{
             var lineitems = document.querySelectorAll('.line-item__property');
  console.log('li',lineitems)
  if(lineitems.length>=1){
    lineitems.forEach((z)=>{
//       if(z.innerText.includes('Fee')){
//         var newLine = z.innerText.replace('Fee','Pfand').replace('for','für');
        
//         z.innerText=newLine;
//       }
      //z.style.visibility="hidden";
      z.style.display="none";
    })
  }
},1200)

}